import createBrowserHistory from 'history/lib/createBrowserHistory';
import configureStore from './redux/configureStore';
import { useRouterHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

const browserHistory = useRouterHistory(createBrowserHistory)({
  basename: __BASENAME__
});

const initialState = window.__INITIAL_STATE__;
const store = configureStore(initialState, browserHistory);
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: (state) => state.router
});

export default store;
export { history };



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/